(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fluxed-reviews-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fxr-home [data-review-grid]').forEach(function (grid) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-review-card]'));
    cards.sort(function (a, b) {
      return String(b.dataset.reviewDate || '').localeCompare(String(a.dataset.reviewDate || ''));
    });
    cards.forEach(function (card) { grid.appendChild(card); });
  });

  } catch(e) { console.error(e); }
})();
})();
